module.exports = __webpack_public_path__ + "img/allbet-bg.611bae24.png";